import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsh2hDisponiblesLayout', {
    template: template,
    controller: NominaDocumentosLayoutsh2hDisponiblesLayoutComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      regla: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsh2hDisponiblesLayoutComponent ($file, $q, $zip, NominaDocumentosLayoutsh2h, NominaDocumentosLayoutsh2hDisponiblesLayout) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.cerrar = cerrar
  $ctrl.generando = false
  $ctrl.confirmando = false
  $ctrl.error = null
  $ctrl.excedidos = []
  $ctrl.invalidos = []
  $ctrl.seleccionados = []
  $ctrl.seleccionadosExcedidos = []
  $ctrl.seleccionar = seleccionar
  $ctrl.actualizar = actualizar
  $ctrl.dividirPagos = dividirPagos
  $ctrl.total = undefined
  $ctrl.error = null

  function $onInit () {
    console.log($ctrl.regla.masivo)
    $ctrl.error = null
    $ctrl.promise = NominaDocumentosLayoutsh2hDisponiblesLayout.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.regla.id_banco, $ctrl.regla.id_moneda, $ctrl.regla.interbancario)
      .then(function (response) {
        $ctrl.data = response.data.colaboradores
          .map(function (item) {
            item.$$valido = !!item.cuenta
            item.$$excede = $ctrl.regla.limite > 0 ? item.$$valido && item.importe > $ctrl.regla.limite : false
            item.$$seleccionado = false

            return item
          })

        $ctrl.nomina = response.data.nomina

        $ctrl.invalidos = $ctrl.data.reduce(function (total, item) {
          return total + (item.$$valido ? 0 : 1)
        }, 0)

        $ctrl.excedidos = $ctrl.data.reduce(function (total, item) {
          return total + (item.$$excede ? 1 : 0)
        }, 0)
      })
      .catch(function (error) {
        $ctrl.error = error.data || error
      })
  }

  function cerrar () {
    $ctrl.onClose()
  }

  function seleccionar (data) {
    $ctrl.seleccionados = data.filter((item) => item.$$seleccionado)
    $ctrl.seleccionadosExcedidos = data.filter((item) => item.$$seleccionado && item.$$excede)

    $ctrl.total = $ctrl.seleccionados.reduce(function (total, item) {
      return total + (item.importe / item.tipo_cambio)
    }, 0)
  }

  function actualizar (data) {
    $ctrl.confirmando = false

    if (data)
      $ctrl.onChange({$event: {data: data}})
  }

  function dividirPagos (data) {
    let pago, nuevoPago
    data.forEach((item) => {
      pago = $ctrl.data.find(element => element.id === item.id)
      pago.$$seleccionado = pago.$$seleccionado || true
      pago.importe = item.importe
      item.resultados.forEach((pagos) => {
        nuevoPago = Object.assign({}, pago)
        nuevoPago.id_pago = pagos.id
        $ctrl.data.push(Object.assign(nuevoPago, pagos))
      })
    })

    $ctrl.data = [].concat($ctrl.data)
    $ctrl.seleccionar($ctrl.data)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsh2h/disponibles/layout/component.js